import type { FunctionalityType } from './enums/FunctionalityType';

// [classname][functionname] = [function1, 2, 3]
const Functionality = new Map<string, Map<string, FunctionalityType[]>>();

Functionality.set('Category', new Map<string, FunctionalityType[]>());
Functionality.get('Category')!.set('ShootingPenalty', ['Shooting']);

export default Functionality;
